import { type ActionContext } from 'vuex';

import { getLeadDataForProperty } from '@/api/ubmContactRequestService';
import { type FetchLeadsQueryParams } from '@/helpers/fetchLeadsByPropertyReferenceId';

import type { LeadInformation, LeadResponse } from './types/leads-types';

export function getInitialState(): LeadInformation {
  return {
    error: undefined,
    loading: false,
    response: { total: 0, currentPage: 0, numberOfPages: 0, data: [] },
  };
}

const getters = {
  getLeads: (state: LeadInformation): LeadResponse => state.response,
  getLeadsError: (state: LeadInformation): string | undefined => state.error,
  getLeadsLoading: (state: LeadInformation): boolean => state.loading,
};

const mutations = {
  setLeads: (state: LeadInformation, newLeads: LeadInformation): void => {
    Object.entries(newLeads).forEach((entry) => {
      const [key, value] = entry;
      (state[key as keyof LeadInformation] as any) = value;
    });
  },
};

const actions = {
  clearLeadsState(context: ActionContext<LeadInformation, any>): void {
    context.commit('setLeads', getInitialState());
  },

  async fetchLeads(
    context: ActionContext<LeadInformation, any>,
    payload: { listerId: string; propertyReferenceId: string; params: FetchLeadsQueryParams },
  ): Promise<void> {
    const { propertyReferenceId, params } = payload;

    context.commit('setLeads', { ...context.state, loading: true });
    try {
      const response = await getLeadDataForProperty(propertyReferenceId, params);

      context.commit('setLeads', { ...context.state, loading: false, response });
    } catch (error) {
      context.commit('setLeads', { ...context.state, error: error.message, loading: false });
    }
  },
};

const leadStore = { state: getInitialState, getters, mutations, actions };
export default leadStore;
